/**
 * Place of Birth — a read-only trigger that opens the full-screen search overlay
 * (a real input here would race the soft keyboard with the results list).
 */
import { SearchIcon } from '../icons'
import { FieldError, FieldLabel } from './FieldLabel'

interface Props {
  value: string | null
  required: boolean
  onOpen: () => void
  error?: string
}

export function PlaceOfBirthField({ value, required, onOpen, error }: Props) {
  return (
    <div className="flex flex-col gap-1.5">
      <FieldLabel required={required}>Place of Birth</FieldLabel>
      <button
        type="button"
        onClick={onOpen}
        className="flex items-center justify-between gap-2 border-0 border-b border-textSeparator pb-2 text-left"
      >
        <span className={`text-labelLarge ${value ? 'text-textPrimary' : 'text-textDisabled'}`}>
          {value || 'Enter place'}
        </span>
        <SearchIcon className="h-5 w-5 shrink-0 text-textSecondary" />
      </button>
      <FieldError message={error} />
    </div>
  )
}
